import { render, staticRenderFns } from "./SupportFiltersWrapper.vue?vue&type=template&id=52b5bae4&scoped=true&"
import script from "./SupportFiltersWrapper.vue?vue&type=script&lang=ts&"
export * from "./SupportFiltersWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SupportFiltersWrapper.vue?vue&type=style&index=0&id=52b5bae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5bae4",
  null
  
)

export default component.exports